import React from 'react'; 
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal, toggleLoading} from "../../../state/ModalSlice/ModalSlice.ts";
import {useBackend} from "../../../hooks/backend/useBackend.ts";
import {CircularProgress, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify';
import { db } from '../../../Config/firebase.ts';
import { updateDoc } from 'firebase/firestore';
import { getDoc } from 'firebase/firestore';
import { doc } from 'firebase/firestore';
import { useState } from 'react';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';

export default function DeleteAdditionalFormFieldsModal() {

    const Dispatch = useAppDispatch();
    const ServiceProviderID = useAppSelector(selectEffectiveUID) 
    const open = useAppSelector((state: RootState) => state.ModalSlice.DeleteAdditionalFormFieldsModalOpen);
    const {questionId,eventId} = useAppSelector((state: RootState) => state.ArbitrarySlice.ForDeleteEventCustomFieldModal)
    const [isLoading, setIsLoading] = useState(false);
    function handleClose() {
        Dispatch(closeModal("DeleteAdditionalFormFieldsModalOpen"))
    }


    // OnSubmit Operations

    const handleSubmit = async (e:any) => {
        e.preventDefault()
        setIsLoading(true)
        try {
          const eventRef = doc(db, 'ServiceProviders', ServiceProviderID, 'Events', eventId);
          
          // Fetch current document
          const eventDoc = await getDoc(eventRef);
          if (!eventDoc.exists()) {
            throw new Error('Event not found');
          }
    
          const currentFields = eventDoc.data().additionalFormFields || [];
          // Filter out the field with matching questionId
          const updatedFields = currentFields.filter((field: any) => field.id !== questionId);
    
          // Update with new array
          await updateDoc(eventRef, {
            additionalFormFields: updatedFields
          });
    
          toast.success('Field deleted successfully');
          handleClose();
        } catch (error) {
          console.error('Error deleting custom field:', error);
          toast.error('Error deleting field');
        } finally {
          setIsLoading(false);
        }
    };

    return (<React.Fragment>

        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },
            }}
            maxWidth="md"
            open={open}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{paddingX: "60px", paddingY: "40px"}} className={"bg-white"}>
                <div className={"header pb-[20px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Delete Additional Form Field</p>
                    {/*<p className={"text-cf_small font-[400] "}>Add New Subscribers to {subscriptionName}</p>*/}
                </div>

                <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                    <CloseIcon/>
                </IconButton></div>

                <div className={"pt-0"}>

                    <p>Are you sure you want to delete the field? This action is irreversible.</p>


                </div>

                <div className={"flex gap-2 pt-8"}>
                <button onClick={(e) => {
                        e.preventDefault();
                        handleClose()
                    }} disabled={isLoading}
                        className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>Cancel
                    </button>
                    
                    <button
                        onClick={handleSubmit} disabled={isLoading}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>
                        {isLoading && <CircularProgress sx={{ color: "white" }} size={20} />}
                        <p className={"ml-2"}>{isLoading ? "Loading" : "Delete Field"}</p>
                    </button>

                </div>
            </DialogContent>

        </Dialog>

    </React.Fragment>);
}